var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blind"},[_c('img',{staticClass:"nothing_img",attrs:{"src":require("@/assets/img/coming.png")}}),_c('span',{staticClass:"dec"},[_vm._v("Coming Soon")])])
}]

export { render, staticRenderFns }